const newsNavigationRoutes = {
  NEWS_HOME: "/",
} as const;

export default newsNavigationRoutes;
